export default __webpack_public_path__ + "static/media/Dan Sang Gum.9958f2a4.jpg";